<template>
    <div>
        <span class="picker" @click="toggleDropdown" v-html="get_icon(selected)"></span>

        <div class="selector-popup" style="display: block;" v-if="!hidden">
            <div class="selector-category">
                <select name="" class="icon-category-select" style="" v-model="category" @change="onChange($event)">
                    <option v-for="(option, index) in EMOJIS" :key="index" :value="option.key">{{option.key}}</option>
                </select>
            </div>
            <div class="fip-icons-container">
                <span @click="selectIcon(icon)" class="fip-box" :title="get_icon(icon)" v-for="(icon, index) in EMOJI_OPTIONS" :key="index">
                    <span class="emoji" v-html="get_icon(icon)"></span>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "EmojiPicker",
    props: {
        value: String,
    },
    components: {},
    watch: {
        value: function(newVal, oldVal) {
            if(oldVal != newVal){
                this.selected = newVal;
            }
            if(!this.selected){
                this.selected = "1f604";
            }
        }
    },
    data() {
        return {
            hidden: true,
            selected: this.value || '1f604',
            category: "People",
            EMOJI_OPTIONS: [],
            EMOJIS: [{
                key: "People",
                value: ["1f604", "1f603", "1f60a", "263a", "1f609", "1f60d", "1f618", "1f61a", "1f61c", "1f61d", "1f633", "1f601", "1f614", "1f60c", "1f612", "1f61e", "1f623", "1f622", "1f602", "1f62d", "1f62a", "1f625", "1f630", "1f605", "1f613", "1f629", "1f62b", "1f628", "1f631", "1f620", "1f621", "1f624", "1f616", "1f606", "1f60b", "1f637", "1f635", "1f632", "1f47f", "1f60f", "1f46e", "1f477", "1f482", "1f476", "1f466", "1f467", "1f468", "1f469", "1f474", "1f475", "1f47c", "1f478", "1f63a", "1f638", "1f63b", "1f63d", "1f63c", "1f640", "1f63f", "1f639", "1f63e", "1f479", "1f47a", "1f648", "1f649", "1f64a", "1f480", "1f47d", "1f4a9", "1f525", "2728", "1f31f", "1f4ab", "1f4a5", "1f4a2", "1f4a6", "1f4a7", "1f4a4", "1f4a8", "1f442", "1f440", "1f443", "1f445", "1f444", "1f44d", "1f44e", "1f44c", "1f44a", "270a", "270c", "1f44b", "270b", "1f450", "1f446", "1f447", "1f449", "1f448", "1f64c", "1f64f", "1f44f", "1f4aa", "1f6b6", "1f3c3", "1f483", "1f46b", "1f46a", "1f48f", "1f491", "1f46f", "1f646", "1f645", "1f481", "1f64b", "1f486", "1f487", "1f485", "1f470", "1f64e", "1f64d", "1f647", "1f3a9", "1f451", "1f452", "1f45f", "1f45e", "1f461", "1f460", "1f462", "1f455", "1f454", "1f45a", "1f457", "1f3bd", "1f456", "1f458", "1f459", "1f4bc", "1f45c", "1f45d", "1f45b", "1f453", "1f380", "1f302", "1f484", "1f49b", "1f499", "1f49c", "1f49a", "2764", "1f494", "1f497", "1f493", "1f495", "1f496", "1f49e", "1f498", "1f48c", "1f48b", "1f48d", "1f48e", "1f464", "1f4ac", "1f463"],
            },{
                key: "Objects",
                value: ["1f38d", "1f49d", "1f38e", "1f392", "1f393", "1f38f", "1f386", "1f387", "1f390", "1f391", "1f383", "1f47b", "1f385", "1f384", "1f381", "1f38b", "1f389", "1f38a", "1f388", "1f38c", "1f52e", "1f3a5", "1f4f7", "1f4f9", "1f4fc", "1f4bf", "1f4c0", "1f4bd", "1f4be", "1f4bb", "1f4f1", "1f4de", "1f4df", "1f4e0", "1f4e1", "1f4fa", "1f4fb", "1f50a", "1f514", "1f4e2", "1f4e3", "23f3", "231b", "23f0", "231a", "1f513", "1f512", "1f50f", "1f510", "1f511", "1f50e", "1f4a1", "1f526", "1f50c", "1f50b", "1f50d", "1f6c0", "1f6bd", "1f527", "1f529", "1f528", "1f6aa", "1f6ac", "1f4a3", "1f52b", "1f52a", "1f48a", "1f489", "1f4b0", "1f4b4", "1f4b5", "1f4b3", "1f4b8", "1f4f2", "1f4e7", "1f4e5", "1f4e4", "2709", "1f4e9", "1f4e8", "1f4eb", "1f4ea", "1f4ee", "1f4e6", "1f4dd", "1f4c4", "1f4c3", "1f4d1", "1f4ca", "1f4c8", "1f4c9", "1f4dc", "1f4cb", "1f4c5", "1f4c6", "1f4c7", "1f4c1", "1f4c2", "2702", "1f4cc", "1f4ce", "2712", "270f", "1f4cf", "1f4d0", "1f4d5", "1f4d7", "1f4d8", "1f4d9", "1f4d3", "1f4d4", "1f4d2", "1f4da", "1f4d6", "1f516", "1f4db", "1f4f0", "1f3a8", "1f3ac", "1f3a4", "1f3a7", "1f3bc", "1f3b5", "1f3b6", "1f3b9", "1f3bb", "1f3ba", "1f3b7", "1f3b8", "1f47e", "1f3ae", "1f0cf", "1f3b4", "1f004", "1f3b2", "1f3af", "1f3c8", "1f3c0", "26bd", "26be", "1f3be", "1f3b1", "1f3b3", "26f3", "1f3c1", "1f3c6", "1f3bf", "1f3c2", "1f3ca", "1f3c4", "1f3a3", "1f375", "1f376", "1f37a", "1f37b", "1f378", "1f379", "1f377", "1f374", "1f355", "1f354", "1f35f", "1f357", "1f356", "1f35d", "1f35b", "1f364", "1f371", "1f363", "1f365", "1f359", "1f358", "1f35a", "1f35c", "1f372", "1f362", "1f361", "1f373", "1f35e", "1f369", "1f36e", "1f366", "1f368", "1f367", "1f382", "1f370", "1f36a", "1f36b", "1f36c", "1f36d", "1f36f", "1f34e", "1f34f", "1f34a", "1f352", "1f347", "1f349", "1f353", "1f351", "1f348", "1f34c", "1f34d", "1f360", "1f346", "1f345", "1f33d"],
            },{
                key: "Places",
                value: ["1f3e0", "1f3e1", "1f3eb", "1f3e2", "1f3e3", "1f3e5", "1f3e6", "1f3ea", "1f3e9", "1f3e8", "1f492", "26ea", "1f3ec", "1f307", "1f306", "1f3ef", "1f3f0", "26fa", "1f3ed", "1f5fc", "1f5fe", "1f5fb", "1f304", "1f305", "1f303", "1f5fd", "1f309", "1f3a0", "1f3a1", "26f2", "1f3a2", "1f6a2", "26f5", "1f6a4", "2693", "1f680", "2708", "1f4ba", "1f689", "1f684", "1f685", "1f687", "1f683", "1f68c", "1f699", "1f697", "1f695", "1f69a", "1f6a8", "1f693", "1f692", "1f691", "1f6b2", "1f488", "1f68f", "1f3ab", "1f6a5", "26a0", "1f6a7", "1f530", "26fd", "1f3ee", "1f3b0", "2668", "1f5ff", "1f3aa", "1f3ad", "1f4cd", "1f6a9"],
            },{
                key: "Nature",
                value: ["1f436", "1f43a", "1f431", "1f42d", "1f439", "1f430", "1f438", "1f42f", "1f428", "1f43b", "1f437", "1f43d", "1f42e", "1f417", "1f435", "1f412", "1f434", "1f411", "1f418", "1f43c", "1f427", "1f426", "1f424", "1f425", "1f423", "1f414", "1f40d", "1f422", "1f41b", "1f41d", "1f41c", "1f41e", "1f40c", "1f419", "1f41a", "1f420", "1f41f", "1f42c", "1f433", "1f40e", "1f432", "1f421", "1f429", "1f43e", "1f490", "1f338", "1f337", "1f340", "1f339", "1f33b", "1f33a", "1f341", "1f343", "1f342", "1f33f", "1f33e", "1f344", "1f335", "1f334", "1f330", "1f331", "1f33c", "1f311", "1f313", "1f314", "1f315", "1f31b", "1f319", "1f30f", "1f30b", "1f30c", "1f320", "2b50", "2600", "26c5", "2601", "26a1", "2744", "26c4", "1f300", "1f301", "1f308", "1f30a"],
            },{
                key: "Symbols",
                value: ["1f51f", "1f522", "1f523", "2b06", "2b07", "2b05", "27a1", "1f520", "1f521", "1f524", "2197", "2196", "2198", "2199", "2194", "2195", "25c0", "25b6", "1f53c", "1f53d", "21a9", "21aa", "2139", "23ea", "23e9", "23eb", "23ec", "2935", "2934", "1f197", "1f195", "1f199", "1f192", "1f193", "1f196", "1f4f6", "1f3a6", "1f201", "1f22f", "1f233", "1f235", "1f234", "1f232", "1f250", "1f239", "1f23a", "1f236", "1f21a", "1f6bb", "1f6b9", "1f6ba", "1f6bc", "1f6be", "1f17f", "267f", "1f6ad", "1f237", "1f238", "1f202", "24c2", "1f251", "3299", "3297", "1f191", "1f198", "1f194", "1f6ab", "1f51e", "26d4", "2733", "2747", "274e", "2705", "2734", "1f49f", "1f19a", "1f4f3", "1f4f4", "1f170", "1f171", "1f18e", "1f17e", "1f4a0", "27bf", "267b", "2648", "2649", "264a", "264b", "264c", "264d", "264e", "264f", "2650", "2651", "2652", "2653", "26ce", "1f52f", "1f3e7", "1f4b9", "1f4b2", "1f4b1", "2122", "274c", "203c", "2049", "2757", "2753", "2755", "2754", "2b55", "1f51d", "1f51a", "1f519", "1f51b", "1f51c", "1f503", "1f55b", "1f550", "1f551", "1f552", "1f553", "1f554", "1f555", "1f556", "1f557", "1f558", "1f559", "1f55a", "2716", "2795", "2796", "2797", "2660", "2665", "2663", "2666", "1f4ae", "1f4af", "2714", "1f518", "1f517", "27b0", "3030", "303d", "1f531", "25fc", "25fb", "25fe", "25fd", "25aa", "25ab", "1f53a", "1f532", "1f533", "26ab", "26aa", "1f534", "1f535", "1f53b", "2b1c", "2b1b", "1f536", "1f537", "1f538", "1f539"]
            }],
        }
    },
    created(){
        this.onChange();
    },
    methods: {
        toggleDropdown(){
            this.hidden = !this.hidden;
        },
        onChange() {
            this.EMOJI_OPTIONS = this.EMOJIS.filter(d => d.key === this.category)[0].value
        },
        get_icon(icon) {
            if(icon){
                return "&#x" + icon + ";";
            }
            return "";
        },
        selectIcon(icon){
            this.hidden = true;
            this.selected = icon;
            this.$emit('input', this.selected)
        }
    }
};
</script>
<style lang="scss">
.picker {
    min-width: 45px;
    border: 1px solid #ced4da;
    border-radius: $radiusSm;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    height: calc(1.5em + 0.75rem + 2px);
    display: inline-block;
    vertical-align: middle;
    background: #fff;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.selector-popup{
    box-shadow: 0 1px 1px rgba(0,0,0,0.04);
    border: 1px solid #E5E5E5;

    position: absolute;
    z-index: 10000;
    background-color: #fefefe;
    padding: 5px;
    height: auto;
    width: 342px;
    margin-top: -1px;
}
.selector-category{
    box-sizing: content-box;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
    font-family: "HelveticaNeue-Light","Helvetica Neue Light","Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif;
}
.selector-category select {
    width: 100%;
}
.fip-icons-container{
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    overflow-y: scroll;
    max-height:300px;
}
.fip-box {
    display: inline-block;
    margin: 2px;
    width: 50px;
    line-height: 42px;
    text-align: center;
    cursor: pointer;
    vertical-align: top;
    height: 40px;
}
</style>
